import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Typography, List, ListItem, ListItemText, Divider
} from '@mui/material';

const CalendarExportDialog = ({ open, onClose, calendarEvents }) => {
    const categories = {
        event: [],
        lodging: [],
        meals: [],
        activities: []
    };

    // Group and sort
    calendarEvents.forEach(event => {
        categories[event.category].push(event);
    });

    const sortByStart = (a, b) => new Date(a.start) - new Date(b.start);
    Object.keys(categories).forEach(cat => {
        categories[cat].sort(sortByStart);
    });

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>📅 Add Event Details to Your Calendar</DialogTitle>

            <DialogContent dividers>
                {Object.entries(categories).map(([category, items]) => (
                    items.length > 0 && (
                        <React.Fragment key={category}>
                            <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
                                {category === 'event' ? 'Event Overview' :
                                    category === 'lodging' ? 'Lodging' :
                                        category === 'meals' ? 'Meals' : 'Activities'}
                            </Typography>
                            <List dense>
                                {items.map((item, idx) => (
                                    <ListItem
                                        key={idx}
                                        button
                                        component="a"
                                        href={item.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{ mb: 0.5 }}
                                    >
                                        <ListItemText
                                            primary={item.title}
                                            secondary={`${item.dateLabel} • ${item.location || ''}`}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                            <Divider sx={{ my: 1 }} />
                        </React.Fragment>
                    )
                ))}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default CalendarExportDialog;
